import Result from './result';
import styles from './results.module.scss';

const getResultKey = item =>
    [item?.Registration_Name, item?.First_Name, item?.Last_Name, item?.Gender]
        .map(value =>
            String(value ?? '')
                .trim()
                .replace(/\s+/g, ' ')
                .toUpperCase()
        )
        .join('|');

const Results = ({ data, focused, handleClick, setFocused, visible }) => {
    if (!data?.length || !visible) {
        return null;
    }

    const items = data.map((item, index) => (
        <Result
            focused={focused}
            handleClick={handleClick}
            index={index}
            item={item}
            key={getResultKey(item)}
            setFocused={setFocused}
        />
    ));

    return (
        <ul id="results" className={styles.Results}>
            {items}
        </ul>
    );
};

export default Results;
